import { baseRoute } from '../../constants/routes';

export const PROFILE_ROUTE = baseRoute + '/user/profile';
export const UPDATE_PROFILE_ROUTE = baseRoute + '/user/profile/update';
export const UPDATE_PROFILE_AVATAR_ROUTE = baseRoute + '/user/profile/avatar';

export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';
